import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Textarea } from '@/components/ui/textarea';

export default function BroadcastModal({ open, onOpenChange, challengeTitle, form, setForm, onSend }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="rounded-3xl border-brand-border max-w-lg" data-testid="broadcast-dialog">
        <DialogHeader><DialogTitle className="font-heading text-brand-text">Enviar mensagem a todas</DialogTitle></DialogHeader>
        <div className="space-y-3">
          <p className="text-xs text-brand-muted">Esta mensagem vai para todas as participantes activas de &quot;{challengeTitle}&quot;.</p>
          <Textarea value={form.message} onChange={e => setForm({ ...form, message: e.target.value })} rows={5} placeholder="Escreve a mensagem..." className="rounded-xl border-brand-border" data-testid="broadcast-message-input" />
          <div className="space-y-2">
            <label className="flex items-center gap-2 text-xs text-brand-text cursor-pointer">
              <input type="checkbox" checked={form.send_push} onChange={e => setForm({ ...form, send_push: e.target.checked })} className="rounded" data-testid="broadcast-push" />
              <span>Enviar push notification</span>
            </label>
            <label className="flex items-center gap-2 text-xs text-brand-text cursor-pointer">
              <input type="checkbox" checked={form.send_email} onChange={e => setForm({ ...form, send_email: e.target.checked })} className="rounded" data-testid="broadcast-email" />
              <span>Enviar também por email</span>
            </label>
          </div>
          <button onClick={onSend} className="w-full bg-brand-green text-white rounded-full py-3 font-medium" data-testid="broadcast-send-btn">Enviar</button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
